import React from 'react'
import HeroSection from '../../components/common/HeroSection/HeroSection'
import Images from '@assets/images';
import Technologies from './Technologies/Technologies';
import BusinessGrowth from './BusinessGrowth/BusinessGrowth'
import SmallCard from '../../components/common/SmallCard/SmallCard';
import { useNavigate } from 'react-router-dom';

function AppDevelopment() {

  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/portfolio');

    setTimeout(() => {
      const element = document.getElementById('apply-section');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100); 
  };

  return (
    <>
      <HeroSection
        badgeText="Top Mobile App Development Company In Surat"
        title="We Build Mobile Apps That"
        highlight=" Elevate User Experience"
        subtitle="Our mobile app development services help businesses create robust, scalable, and user-friendly mobile applications for Android and iOS platforms. From concept to deployment, we ensure your app not only meets but exceeds expectations."
        buttonLabel="Start Your App Project"
        // buttonLink="/contact"
        image={Images.webHero}
        onClick={handleClick}
      />
      <Technologies />
      <BusinessGrowth />
      <SmallCard />
    </>
  )
}

export default AppDevelopment;